<template lang="html">
    <div>
        <!-- Use the AppTitle component -->
        <AppTitle>
            <template #title>หน้าหลัก</template>
            <template #subtitle></template>
            <template #breadcrumb>หน้าหลัก</template>
        </AppTitle>

        <Widget />

        <div class="row">
            <div class="col-md-12">
                <div class="tile">
                    <ChartMedicineCabinet />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="tile">
                    <ChartRoomTemperature />
                </div>
            </div>
        </div>

    </div>
</template>
<script setup>
import ChartMedicineCabinet from '@/components/ChartMedicineCabinet.vue';
import ChartRoomTemperature from '@/components/ChartRoomTemperature.vue';
import Widget from '@/components/Widget.vue';
import AppTitle from '@/layouts/AppTitle.vue';


</script>
<style lang="">

</style>